<script>
	import CarritoMovimientos from './components/CarritoMovimientos.svelte';
	import Helper from './components/Helper.svelte';
    import DatagridRow from './componentes/DatagridRow.svelte';
    import DatagridTitle from './componentes/DatagridTitle.svelte';
    import DatagridCell from './componentes/DatagridCell.svelte';
    import Datagrid from './componentes/Datagrid.svelte';

    import Alert from './componentes/Alert.svelte';
	import MovimientoTraslado from './componentes/Movimientos/MovimientoTraslado.svelte';
	import MovimientoSalida from './componentes/Movimientos/MovimientoSalida.svelte';
	import MovimientoEntrada from './componentes/Movimientos/MovimientoEntrada.svelte';
	import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';
	import Titlesection from './components/Titlesection.svelte';
	import AnimationContainer from './components/AnimationContainer.svelte';
	import Navbar from './components/Navbar.svelte';
    import { push } from 'svelte-spa-router';
    import { urlapi, permisos, permisos_struct,permisos_title,miPermiso,iduser,login,sucursal,sucursalStore } from './stores/store';
    import { object2array, postData, isJson, mergeDeep, moneda } from './scripts';
    import moment from 'moment'

    export let params = {}

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if(
                $miPermiso.movimientos.access===false
                || ($miPermiso.movimientos.edit!==true && params.id!='new')
                || ($miPermiso.movimientos.insert!==true && params.id=='new')
            ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    let id=false;
    // status
    let disabled=false;
    let disabled2=false; 
    let guardando=false;
    let insertando=false;
    let error=false;
    let carritoObj=false;

    let estado='P';

    let tipo='0'; //'0'
    let origen='0'; //'0'
    let destino='0'; //'0'
    let cantidadLineas=0;
    let totalItems=0;
    let observaciones=''; //''
    let osave=null;
    let nombre=false;
    let fecha=false;
    let fecha_anul=false;
    let nombre_anul=false;
    let offcanvas_masivo=false;
    let Bsoffcanvas_masivo=false;

    let action=false; // false
    let lineEdit=false;
    //let action=false;
    let masiveText='';
    let masiveError=false;
    let codigo='';
    let cantidad='';
    let descripcion=false;
    let codigoInput=null;
    let cantidadInput=null;
    
    let sucursales=[];
    Object.keys($sucursalStore).map(function(value) { sucursales=[...sucursales,{[value] :$sucursalStore[value]}] });
    sucursales=[{'0':'Seleccione Sucursal'},...sucursales]

    let datagrid=[]

    let seleccionado=false;
    let count_seleccionado=0;
    let checkButton=false;
    let helper=false;

    function openMasivo()
    {
        masiveText='';
        Bsoffcanvas_masivo = new bootstrap.Offcanvas(offcanvas_masivo)
        Bsoffcanvas_masivo.show()
        codigoInput.onlyFocusInNum(400)
    }
    function closeMasivo()
    {
        Bsoffcanvas_masivo.hide()
    }
  
    let function_salir = function () { push('/movimientos'); }

    let save = function () {
        eliminarVacios();
        disabled=true;
        disabled2=true;
        if(tipo=='0')
        {
            error='Seleccione el <strong>Tipo</strong> de movimiento';
            disabled=false;
            disabled2=false;
        } else if((tipo=='S' || tipo=='T') && origen=='0') {            
            error='Seleccione el <strong>Sucursal Origen</strong>';
            disabled=false;
            disabled2=false;            
        } else if((tipo=='I' || tipo=='T') && destino=='0') {
            error='Seleccione el <strong>Sucursal Destino</strong>';
            disabled=false;
            disabled2=false;            
        } else if(datagrid.length==0) {
            error='No tiene productos asignados';
            disabled=false;
            disabled2=false;            
        } else {
            error=false;
            let result={
                'cmd':'movimientos_guardar',
                'id':id,
                'tipo':tipo,
                'origen':origen,
                'destino':destino,
                'observaciones':observaciones,
                'estado':'E',
                'productos':datagrid,
                'iduser':$iduser,
                'totallineas':cantidadLineas,
                'totalitems':totalItems,
                'sucursal': $sucursal
            }

            disabled=false;
            disabled2=false;
            
            postData($urlapi, [result])
            .then(data => {
                disabled=false;
                disabled2=false;                

                if(data[0].result===true)
                {
                    function_salir()
                } else {
                    //let sucursalText = $sucursalStore[ Object.keys($sucursalStore)[Object.keys($sucursalStore).findIndex(o => o == origen)] ];
                    let sucursalText =$sucursalStore[origen];
                    object2array(data[0].productos).forEach(function(element,index) {
                        if(element.error===true)
                        {
                            if(error===false) { error='';}
                            error+="<p class='mb-1 border-top border-white lh-1 pt-1 pb-1 fs-6'><strong>ERROR:</strong> <span class='text-black'><strong>"+element.codigo+"-"+element.descripcion+"</strong> no tiene suficiente existencia <br/><strong>"+sucursalText+"</strong> [Existencia: "+element.existencia_sucursal+"] [Solicitado: "+element.cantidad+"]</span></p>";
                        }
                    })                    
                }
            });   
        }
    }

    let anular=function() {
        error=false;
        let result={
            'cmd':'movimientos_anular',
            'id':id,
            'estado':'A',
            'tipo':tipo,
            'origen':origen,
            'destino':destino,            
            'productos':datagrid,
            'iduser':$iduser,
            'sucursal': $sucursal
        }
        postData($urlapi, [result])
        .then(data => {
            function_salir()
        });
    }

    let pendiente = function () {
        eliminarVacios();
        if(tipo=='0')
        {
            error='Seleccione el <strong>Tipo</strong> de movimiento';
        } else if((tipo=='S' || tipo=='T') && origen=='0') {            
            error='Seleccione el <strong>Sucursal Origen</strong>';
        } else if((tipo=='I' || tipo=='T') && destino=='0') {
            error='Seleccione el <strong>Sucursal Destino</strong>';
        } else if(datagrid.length==0) {
            error='No tiene productos asignados';
        } else {
            error=false;
            let result={
                'cmd':'movimientos_guardar',
                'id':id,
                'tipo':tipo,
                'origen':origen,
                'destino':destino,
                'observaciones':observaciones,
                'estado':'P',
                'productos':datagrid,
                'iduser':$iduser,
                'totallineas':cantidadLineas,
                'totalitems':totalItems,
                'sucursal': $sucursal
            }
            postData($urlapi, [result])
            .then(data => {
                function_salir()
            });             
        }
    }

    let load= function() {
        disabled=true;
        disabled2=true;
        postData($urlapi, [{ 'cmd':'movimientos_edit', 'id':id }])
        .then(data => {
                nombre=data[0].result.usuario;
                estado=data[0].result.estado;
                tipo=data[0].result.tipo;
                origen=data[0].result.origen;
                destino=data[0].result.destino;
                observaciones=data[0].result.observaciones;
                fecha=data[0].result.fecha;
                
                fecha_anul=data[0].result.fecha_anul;
                nombre_anul=data[0].result.usuario_anul;

                if(estado=='P') { disabled=false; disabled2=false; }
                if(estado=='E') { disabled=true; disabled2=false; }
                if(estado=='A') { disabled=true; disabled2=false; }

                datagrid=[...object2array(data[0].productos).map(p => { return { ...p, cantidad: ~~p.cantidad, lock:true, encontrado:true} } )]
                linesReload();
                if(estado=='P') {
                    setTimeout(() => {
                        carritoObj.buscar_producto_nuevo()
                    }, 500);
                }                
        });
    }


    let deleteAll=function() {
        datagrid=[]
        linesReload();
        seleccionado=false;
    }

    let linesReload=function() {
        let lines=1;
        totalItems=0;
        datagrid.forEach(function(element,index) {
            datagrid[index].linea=lines
            lines++;
            totalItems+=datagrid[index].cantidad;
        })
        cantidadLineas=lines-1;
    }

    if(viewPage===true)
    {
        if(params.id!=0 && params.id!='new')
        {
            insertando=false;
            id=params.id;
            load();
        } else {
            insertando=true;
            id=0;
            setTimeout(() => {
                carritoObj.buscar_producto_nuevo()
            }, 500);
        }
    }

    function eliminarVacios()
    {
        let seleccionados = datagrid.filter(function(item){
                if (item.encontrado === true) {
                    return true;
                } else {
                    return false;
                }
        });
        datagrid=seleccionados
    }

    let agregarLineaMasiva=async function()
    {
        let atemp=masiveText.split(String.fromCharCode(10))
        let encontrado=null;
        let productosEncontrados=[];
        let objectosBuenos=[];
        atemp.forEach(function(element,index) {
            encontrado=element.match(/(\d+)/g)
            if(encontrado!==null)
            {
                productosEncontrados=[...productosEncontrados,{codigo:encontrado[0],cantidad:~~encontrado[1]}]
            }
        })

        if(productosEncontrados.length==0) {
            masiveError='No se encontro ningún codigo';
        } else {
            masiveError=false;
            postData($urlapi, [{'cmd':'movimientos_masiveVerify','codigos':productosEncontrados}])
            .then(data => {
                
                object2array(data[0].result).forEach(function(element,index) {
                    if(element.error===true)
                    {
                        if(masiveError===false) { masiveError='';}
                        masiveError+="<p class='mb-1 border-top border-white lh-base'><strong>ERROR:</strong> <span class='text-black'>Código <strong>"+element.codigo+"</strong> NO ENCONTRADO</span></p>";
                    } else {
                        if(element.cantidad==0) element.cantidad=1;
                        objectosBuenos=[...objectosBuenos,{'linea':0,'codigo':element.codigo,'descripcion':element.descripcion,'cantidad':element.cantidad,'lock':true, 'encontrado':true}]
                    }
                })
                if(masiveError===false)
                {
                    eliminarVacios();
                    datagrid=[...datagrid,...objectosBuenos]
                    closeMasivo();
                    setTimeout(() => {
                        carritoObj.buscar_producto_nuevo()    
                    }, 300);
                }

            });
        }
    }



/*    let verificarProducto=async function(e)
    {
        postData($urlapi, [{'cmd':'productos_getProducto','codigo':codigo}])
        .then(data => {
            if(data[0].result===false)
            {
                descripcion='PRODUCTO_NOTFOUND';
                codigoInput.focusIn()
            } else {
                descripcion=data[0].result.descripcion;
                cantidadInput.focusIn()
            }
        });
    }*/

    let eventTipo=function(e) {
        if(tipo=='S' || tipo=='I')
        {
            origen=$sucursal;
            destino=$sucursal;
        } else {
            origen=$sucursal
            destino='0'
        }
    }

    linesReload();

</script>

{#if viewPage===true}
<Navbar />

<AnimationContainer marginTop=0>
    <Titlesection>
        <span slot="title"><i class="bi bi-arrows-move me-1" />Movimientos
        
        {#if insertando===true}
            <small class='badge bg-light text-success text-uppercase'>Nuevo</small>
        {:else}
            <small class='badge bg-light text-success text-uppercase'>Editando {id}</small>
        {/if}
        </span>
        <span slot="toolbar">

            {#if estado=='P'}
                <div class="btn-group">
                    <button {disabled} class="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" on:mouseenter={()=>helper='Guardar'} on:mouseleave={()=>helper=false}>
                        {#if guardando===true}
                            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        {/if}                
                        <i class="bi bi-save me-1"></i>
                    </button>
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <ul class="dropdown-menu p-0" aria-labelledby="dropdownMenuButton1">
                        <!-- svelte-ignore missing-declaration -->
                        <li><a class="dropdown-item2 btn btn-warning text-decoration-none text-black w-100 rounded-0" on:click={pendiente} ><i class="bi bi-clock-history me-1"></i>Pendiente</a></li>
                        <li><a class="dropdown-item2 btn btn-success text-decoration-none text-white w-100 rounded-0" on:click={save} ><i class="bi bi-save me-1"></i>Emitir</a></li>
                    </ul>
                </div>

                {#if action===false && estado=='P'}
                    <button disabled={disabled} on:click={()=>carritoObj.buscar_producto_nuevo()} class='btn btn-primary' on:mouseenter={()=>helper='Ingresar Producto'} on:mouseleave={()=>helper=false}><i class="bi bi-plus-circle"></i></button>
                    <button disabled={disabled} on:click={openMasivo} class='btn btn-info text-white' on:mouseenter={()=>helper='Ingresar Productos Masivos'} on:mouseleave={()=>helper=false}><i class="bi bi-stack-overflow"></i></button> 
                    <button disabled={disabled} on:click={()=>carritoObj.openFavorito()} class='btn btn-warning' on:mouseenter={()=>helper='Productos Favoritos'} on:mouseleave={()=>helper=false}><i class="bi bi-star"></i></button>
                    
                    <!-- <span on:mouseenter={()=>helper='Editar Registro'} on:mouseleave={()=>helper=false}><button disabled={!seleccionado || disabled} class='btn btn-success' on:click={ ()=>action_edit(seleccionado) }><i class="bi bi-pencil-square"></i>{count_seleccionado}</button></span> -->

                    <span on:mouseenter={()=>helper='Eliminar Registro'} on:mouseleave={()=>helper=false}>
                        <button disabled={!count_seleccionado!=0 || disabled} class='btn btn-danger pe-1 ps-1' on:click={ ()=>carritoObj.deleteSelected() }><i class="bi bi-trash"></i><span class="badge bg-white text-danger ps-1 pe-1 ms-1">{count_seleccionado}</span></button>
                    </span>
                    
                    <span on:mouseenter={()=>helper='Seleccionar/Deseleccionar Productos'} on:mouseleave={()=>helper=false}>
                        <button disabled={disabled}
                            class='btn btn-secondary' on:click={()=>carritoObj.checkAll()}
                            class:btn-success={checkButton === true}
                            class:btn-secondary={checkButton === false}                    
                            >
                                <i 
                                class:bi-check-square={checkButton === true}
                                class:bi-square={checkButton === false}
                                class="bi"></i>
                        </button>
                    </span>


                    <Modal classButton='btn-danger' iconButton='bi-x-diamond' functionSi={deleteAll} title='ADVERTENCIA' {disabled} on:mouseenter={()=>helper='Eliminar Todos los Registros'} on:mouseleave={()=>helper=false}>
                        Esta seguro que desea <strong>Eliminar</strong> todos los registros?<br/>
                        Se perderán los datos ingresados
                    </Modal>
                {/if}                

            {:else if estado=='E'}
                <Modal classButton='btn-danger' iconButton='bi-file-earmark-x' functionSi={anular} title='ADVERTENCIA' disabled={disabled2} on:mouseenter={()=>helper='Anular'} on:mouseleave={()=>helper=false}>
                    Esta seguro que desea <strong>Anular</strong> el documento?<br/>
                    Se van a revertir todos los datos
                </Modal>
            {/if}

            <Modal classButton='btn-warning btn-sm' iconButton='bi-box-arrow-left' functionSi={function_salir} title='ADVERTENCIA' disabled={disabled2} on:mouseenter={()=>helper='Salir'} on:mouseleave={()=>helper=false}>
                Esta seguro que desea <strong>Salir</strong>?<br/>
                Se perderán los cambios realizados
            </Modal>

        </span>
    </Titlesection>

    {#if error!==false}
    <div class="col-12 mb-2">
            <Alert parpadea disableMarginBottom valign='top'>{@html error}</Alert>
    </div>
    {/if}

    <div class="row mt-2">
        <div class="col-12 col-lg-3 mb-2">
            <Input label='Tipo' {disabled} bind:value={tipo} tipo='select' datos={[{'0':'Seleccione Tipo'},{'I':'INGRESO'},{'S':'SALIDA'},{'T':'TRASLADO'}]} on:change={eventTipo}/>
        </div>

        <!-- {#if tipo=='S' || tipo=='T'} -->
        {#if tipo=='S'}
            <div class='col-12 col-lg-3 mb-2'>
                <Input label='Origen' bind:value={sucursales[origen][origen]} tipo='text'
                class='mb-2' disabled={true}
                />
            </div>
        {/if}

        {#if tipo=='I'}
            <div class='col-12 col-lg-3 mb-2'>
                <Input label='Destino' value={sucursales[destino][destino]} tipo='text'
                class='mb-2' disabled={true}
                />
            </div>
        {/if}

        {#if tipo=='T'}
            <div class='col-12 col-lg-3 mb-2'>
                <Input label='Origen' bind:value={origen} tipo='select'
                datos={sucursales} 
                class='mb-2' {disabled}
                />
            </div>
        {/if}
        
        <!-- {#if tipo=='I' || tipo=='T'} -->
        {#if tipo=='T'}        
            <div class='col-12 col-lg-3 mb-2'>
                <Input label='Destino' bind:value={destino} tipo='select'
                datos={sucursales} 
                class='mb-2' {disabled} />
            </div>
        {/if}

    </div>

    <!-- INGRESO MASIVO -->
    <div class="offcanvas offcanvas-end" style='width:700px;' bind:this={offcanvas_masivo} tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
          <h5 id="offcanvasRightLabel">Ingreso Masivo</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body pt-0">
            <div class="container-fluid border-top border-bottom pt-2 pb-0">
                <div class="row ">
                    <div class='col-12 mb-2'>
                        <Input height=10 label='Ingreso Masivo' bind:value={masiveText} tipo='textarea' autofocus={true} bind:this={codigoInput}/>
                    </div>
                    <div class='col-12'>
                        <button class='btn btn-success' on:click={agregarLineaMasiva} on:mouseenter={()=>helper='Ingresar Masivo'} on:mouseleave={()=>helper=false}><i class="bi bi-save me-1"></i>Ingresar</button>
                        <button class='btn btn-danger' on:click={closeMasivo} on:mouseenter={()=>helper='Salir del ingreso'} on:mouseleave={()=>helper=false}><i class="bi bi-arrow-return-left me-1"></i> Salir</button>
                    </div>                        
                </div>
                <div class='col-12 mb-4 mt-2'>
                    {#if masiveError===false}
                        <!-- <Alert tipo='info' disableMarginBottom animation={false}>INGRESAR LISTADO DE PRODUCTOS <small><strong>[CODIGO CANTIDAD]</strong></small></Alert> -->
                    {:else}
                        <Alert parpadea disableMarginBottom animation={false} valign=top>{@html masiveError}</Alert>
                    {/if}
                </div>
            </div>
            <div class="row mb-4 mt-3">
                <div class='col-6'>
                    <p class='text-warning mb-1 p-0 fw-bold lh-1' style='font-size:0.8em;'>FORMATO:</p>
                    <p class='mb-2 p-2 bg-light text-secondary lh-1 border d-inline-block rounded-1'>CODIGO, CANTIDAD</p>
                </div>
                <div class='col-6'>
                    <p class='text-warning mb-1 p-0 fw-bold lh-1' style='font-size:0.8em;'>EJEMPLO:</p>
                    <p class='mb-2 p-2 bg-light text-secondary  border d-inline-block rounded-1'>10000001, 34<br/>20000001, 100<br/>30000001, 120<br/>40000001, 140<br/>50000001, 95</p>
                </div>                
            </div>

        </div>
    </div>


    <div class="row">

        <div class="col-12">
 
            
            <CarritoMovimientos bind:factura={datagrid} bind:this={carritoObj} 
                activo={disabled}
                bind:countSelected={count_seleccionado}
                bind:checkButton={checkButton}
                on:reload={linesReload}
            />

            <div class="row mt-3">
                <div class="col-12 col-lg-6 mb-2">
                    <p class='text-warning'>{cantidadLineas} Lineas Generadas - Total de {totalItems} items</p>
                    {#if fecha!==false}
                        <p class='text-secondary mb-1 pb-0 lh-1 border-top pt-2'><i class="bi bi-calendar3 me-1"></i><small>Generado el <strong>{moment(fecha, ["YYYY-MM-DD HH:mm:ss"]).format('DD/MM/YYYY, HH:mm:ss')}</strong></small></p>
                    {/if}
                    {#if nombre!==false}
                        <p class='text-secondary mb-0 pb-0 lh-1'><i class="bi bi-person me-1"></i><small>Por el usuario <strong>{nombre}</strong></small></p>
                    {/if}
                    {#if estado=='P'}
                        <p class='text-secondary mb-0 pb-0 lh-1 border-top pt-2 mt-2'><i class="bi bi-flag me-1"></i><small>Estado: <strong class='text-warning'>PENDIENTE</strong></small></p>
                    {:else if  estado=='E'}
                        <p class='text-secondary mb-0 pb-0 lh-1 border-top pt-2 mt-2'><i class="bi bi-flag me-1"></i><small>Estado: <strong class='text-success'>EMITIDO</strong></small></p>
                    {:else if  estado=='A'}
                        <p class='text-secondary mb-0 pb-0 lh-1 border-top pt-2 mt-2'><i class="bi bi-flag me-1"></i><small>Estado: <strong class='text-danger'>ANULADO</strong></small></p>
                        <p class='text-secondary mb-1 pb-0 lh-1 mt-2'><i class="bi bi-calendar3 me-1"></i><small>Anulado el <strong>{moment(fecha_anul, ["YYYY-MM-DD HH:mm:ss"]).format('DD/MM/YYYY, HH:mm:ss')}</strong></small></p>
                        <p class='text-secondary mb-0 pb-0 lh-1'><i class="bi bi-person me-1"></i><small>Anulado por el usuario <strong>{nombre_anul}</strong></small></p>
                    {/if}
                </div>   
                <div class="col-12 col-lg-6 mb-2">
                    <Input label='Observaciones' bind:value={observaciones} tipo='textarea' len=100 {disabled}/>
                </div>                             
            </div>

            
        </div>
    </div>
    
    <Helper bind:text={helper}></Helper>
</AnimationContainer>
{/if}